export enum RedirectionTypeEnum {
  auto = 0,
  self = 1,
  blank = 2,
  self_instance = 3,
}
